import React, {
  useMemo,
  useState,
  useEffect,
  useCallback,
  createContext,
} from 'react'
import { useSearchParams } from 'next/navigation'

interface IFleetContext {
  passengers: number[]
  vehicleClasses: ('vans' | 'cars' | 'suvs')[]
  transmission: 'default' | 'manual' | 'automatic'
  onSelect: (
    _name: keyof Omit<IFleetContext, 'onSelect'>,
  ) => (_value: number | string) => void
}

export const FleetContext = createContext({} as IFleetContext)

export const FleetProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const searchParams = useSearchParams()
  const carClass = searchParams.get('class')
  const [filters, setFilters] = useState<Omit<IFleetContext, 'onSelect'>>({
    passengers: [],
    vehicleClasses: [],
    transmission: 'default',
  })

  useEffect(() => {
    if (!!carClass) {
      // @ts-ignore
      setFilters(prev => ({
        ...prev,
        vehicleClasses: [carClass],
      }))
    }
  }, [carClass])

  const onSelect = useCallback(
    (key: keyof typeof filters) => (value: string | number) => {
      setFilters(prev => ({
        ...prev,
        [key]:
          key === 'transmission'
            ? value
            : // @ts-ignore
            prev[key].includes(value)
            ? prev[key].filter(_v => _v !== value)
            : [...prev[key], value],
      }))
    },
    [],
  )

  const value = useMemo(() => ({ ...filters, onSelect }), [filters, onSelect])
  return <FleetContext.Provider value={value}>{children}</FleetContext.Provider>
}
